<template>
  <article class="order-page">
    <section class="order-container">
      <header>
        <div class="thumb-wrap"><img :src="ScopeGoodsInfo.GoodsLogoUrl" alt="" /></div>
        <div class="text-description">
          <div>
            <h4>业务名称:{{ GoodsAndService }}</h4>
            <div class="gray-text">
              <p>联系人:{{ submitInfo.Contact }}</p>
              <p>联系电话:{{ submitInfo.Mobile }}</p>
              <p>服务时间:{{ submitInfo.Date }} {{ submitInfo.Time }}</p>
              <p>客户地址:{{ submitInfo.Address }}</p>
              <p>客户备注:{{ submitInfo.Remarks }}</p>
            </div>
          </div>
          <span>x{{ submitInfo.GoodsList[0].Count }}</span>
        </div>
      </header>

      <div class="show-price">
        <p>
          <span>商品金额</span>
          <span>
            <i class="iconfont icon-renminbi"></i>
            {{ PriceInfoString }}
          </span>
        </p>
        <p>
          <span>合计:</span>
          <span class="red-text">
            <i class="iconfont icon-renminbi"></i>
            {{ TotalPrice }}
          </span>
        </p>
      </div>

      <p class="gray-text">消费提醒:货款直接给商家,由商家承担全部售后服务</p>
    </section>

    <scope-content-footer :btnText="footBtnText" :isHavePrice="true" :goodsPrice="TotalPrice" @createOrder="createOrder"></scope-content-footer>
  </article>
</template>

<script>
import ScopeContentFooter from './child-components/ScopeContentFooter';
import orderApi from '../request/orderApi';
export default {
  name: 'ScopeSubmitOrder',
  data() {
    return {
      showGoBack: true,
      //foot-parameter-------------------
      footBtnText: '提交预订',
      goodsPrice: true,
      submitInfo: {},
      orderInfo: {},
      ScopeGoodsInfo: {},
      chooseExtraList: []
    };
  },
  components: {
    ScopeContentFooter
  },
  activated() {
    this.getRouterData();
  },
  methods: {
    getRouterData() {
      if (this.$route.params.submitInfo && this.$route.params.ScopeGoodsInfo) {
        this.submitInfo = this.$route.params.submitInfo;
        this.ScopeGoodsInfo = this.$route.params.ScopeGoodsInfo;
        this.chooseExtraList = this.$route.params.chooseExtraList;
      } else {
        this.$Message.warning('联系人资料缺失!请补全');
        this.$router.replace({
          name: 'MainIndexPage',
          params: {
            page: 'scopeindex'
          }
        });
      }
    },
    createOrder() {
      var that = this;
      this.submitInfo.SetDate = this.submitInfo.Date;
      if (this.submitInfo.Time != '') {
        this.submitInfo.SetDate += ' ' + this.submitInfo.Time;
      }
      if (this.ScopeGoodsInfo.IsPickup) {
        this.submitInfo.IsPickup = 1;
      }
      if (this.orderInfo.ID) {
        this.payRequest();
      } else {
        orderApi.createScopeOrder(this.submitInfo).then(sucRes => {
          let result = sucRes;
          if (result.success) {
            that.orderInfo = result.data;
            that.$Message.success(result.message);
            that.payRequest();
          }
        });
      }
    },
    payRequest() {
      let that = this;
      let sendOpenId = '';
      // if (MiniOpenId && MiniOpenId.length > 0) {
      //   // 小程序时跳转
      //   sendOpenId = MiniOpenId;
      //   let url = '../webpayprocess/webpayprocess?ordertype=0&id=' + that.orderInfo.ID + '&businessid=' + BusinessID;
      //   wx.miniProgram.navigateTo({
      //     url: url
      //   });
      // } else {
      // 正常访问时执行
      //				sendOpenId = OpenId;
      //				this.$http.get(host + 'Payment/getWeChatPayParamsV2', {
      //						params: {
      //							openid: sendOpenId,
      //							id: that.orderInfo.ID,
      //							type: BusinessID,
      //							ordertype: 1
      //						}
      //					}).then(function(response) {
      //						if(response.body.success) {
      //							var result = response.body.data;
      //							wx.chooseWXPay({
      //								timestamp: response.body.data.timeStamp,
      //								nonceStr: response.body.data.nonceStr,
      //								package: response.body.data.package,
      //								signType: response.body.data.signType,
      //								paySign: response.body.data.paySign,
      //								success: function(resPay) {
      //									console.log(resPay);
      //									that.$Message.success(resPay + "支付成功！");
      //									window.host.href = "https://www.callmefix.net/wechat/zsyuntu.aspx";
      //								}
      //							});
      //						}
      //					});
      this.$router.push({
        name: 'PaymentSelector',
        params: {
          id: that.orderInfo.ID,
          type: 2
        }
      });
      // }
    }
  },
  computed: {
    TotalPrice() {
      var that = this;
      var totalPrice = 0;
      totalPrice += this.ScopeGoodsInfo.AdultPrice * this.submitInfo.GoodsList[0].Count;
      this.chooseExtraList.forEach(obj => {
        totalPrice += obj.Price * that.submitInfo.GoodsList[0].Count;
      });
      return totalPrice;
    },
    GoodsAndService() {
      var str = '';
      str += this.ScopeGoodsInfo.ScopeName;
      if (this.submitInfo.GoodsList[0].ExtraList.length > 0) {
        this.submitInfo.GoodsList[0].ExtraList.forEach(val => {
          str += '-' + val.ServiceName;
        });
      }
      return str;
    },
    PriceInfoString() {
      var str = '';
      //			str += this.ScopeGoodsInfo.AdultPrice + "[" + this.ScopeGoodsInfo.ScopeName + "]";
      str += this.ScopeGoodsInfo.AdultPrice;
      if (this.chooseExtraList.length > 0) {
        this.chooseExtraList.forEach(val => {
          //					str += (val.Price >= 0 ? "+" : "") + val.Price + "[" + val.ServiceName + "]";
          str += (val.Price >= 0 ? '+' : '') + val.Price;
        });
      }
      return str;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/ScopeSubmitOrder.vue